import React from "react";
import "./SuccessPage.scss";
import CheckIcon from "@mui/icons-material/Check";
import MuiButton from "../../components/basicComponent/MuiButton";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import HistoryIcon from "@mui/icons-material/History";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import axios from "axios";
import { UtilService } from "../../services/shared/UtilService";
import { useLocation, useNavigate } from "react-router-dom";
import {
  replaceEMTwithEWTS,
  splitCountryCode,
  splitWithLookup,
} from "../../constants/helper";

const FlightBookingConfirmation = () => {
  const location = useLocation();
  const bookingRes = location.state?.bookingRes;
  console.log("bookin", bookingRes);
  const addonServicesData = location.state?.otherCharges || {};
  const seatInfo = addonServicesData?.selectedSeats || [];
  const mealInfo = addonServicesData?.selectedMeal || [];
  const baggageInfo = addonServicesData?.selectedBaggage || [];
  const transactionId = location.state?.id;
  const passengerDetails = bookingRes?.passengerDetails || [];
  const travellers = bookingRes?.travellersDetail || {};
  const flightInfo = bookingRes?.passengerDetails?.[0];
  const bookingId = location.state?.bookingRes?.transactionScreenId;
  const outBoundFlight = passengerDetails.find(
    (pax: any) => pax.tripType === "OutBound"
  );

  const inBoundFlight = passengerDetails.find(
    (pax: any) => pax.tripType === "InBound"
  );
  const navigate = useNavigate();
  const id = location.state?.bookingRes?.transactionScreenId;
  const bookingDate = location.state?.bookingRes?.bookingDate?.split?.("T")[0];
  const downloadTicket = async () => {
    try {
      const response = (await UtilService.downloadTicket(transactionId)) as any;
      // Create a blob link
      const blob = new Blob([response?.data], { type: "application/pdf" });
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link and simulate click
      const link = document.createElement("a");
      link.href = blobUrl;

      // Optional: Use Content-Disposition or fallback filename
      const contentDisposition = response.headers["content-disposition"];
      const fileNameMatch = contentDisposition?.match(/filename="(.+)"/);
      const traveller = travellers?.AdultTraveller?.[0];
      const fileName = traveller
        ? `${traveller.Title} ${traveller.FirstName} ${traveller.LastName}.pdf`
        : "ticket.pdf";
      const cleanFileName = fileName.replace(/[^\w.-]/g, "_");
      link.download = cleanFileName;

      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.log("error while download ticket", error);
    }
  };
  const renderFlightInfo = (flight: any, title: string) => (
    <div className="flight-info mb-4">
      <div className="card">
        <div className="card-body">
          <div className="row">
            <div className="col-md-12">
              <div className="flight-route">
                <div className="row">
                  <div className="col-md-3">
                    <div className="departure">
                      <p className="text-muted mb-0">Departure</p>
                      <h3 className="h3">{flight?.origin}</h3>
                      <p className="mb-0">
                        {new Date(flight?.departureDate).toLocaleDateString(
                          "en-GB",
                          {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          }
                        )}
                      </p>
                      <p className="fs-5 fw-bold">{flight?.departureTime}</p>
                    </div>
                  </div>
                  <div className="col-md-3 text-left flight-path">
                    <div className="flight-duration">
                      <p className="text-muted text-center">Direct Flight</p>
                      <div className="flight-line">
                        <div className="plane-icon">✈</div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 text-center">
                    <div className="arrival">
                      <p className="text-muted mb-0">Arrival</p>
                      <h4 className="h4">{flight?.destination}</h4>
                      <p className="mb-0">
                        {" "}
                        {new Date(flight?.arrivalDate).toLocaleDateString(
                          "en-GB",
                          {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          }
                        )}
                      </p>
                      <p className="fs-5 fw-bold">{flight?.arrivalTime}</p>
                    </div>
                  </div>
                  <div className="col-md-3 border-start border-light">
                    <div className="flight-details ms-5">
                      <p className="text-muted">Airline</p>
                      <p className="fw-bold">{flight?.flightName}</p>
                      <p className="text-muted">Flight Number</p>
                      <p className="fw-bold">{`${flight?.airlineCode}${flight?.airlineNo}`}</p>
                      <p className="text-muted">Class</p>
                      <p className="fw-bold">{flight?.cabinClass}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="flight-confirmation-container">
      <div className="container">
        <div className="confirmation-header bg-white p-4 rounded-top shadow-sm">
          <div className="row align-items-center">
            <div className="col-md-9">
              <h1 className="h2 mb-0 d-flex booking-head">
                {/* <button
                  className="btn btn-light rounded-circle d-flex align-items-center justify-content-center me-2"
                  style={{ width: "40px", height: "40px" }}
                >
                  <ArrowBackIcon />
                </button> */}
                Flight Booking Confirmation
              </h1>
              <p className="lead text-success mb-0 success-pera">
                <CheckIcon /> Your booking has been confirmed
              </p>
            </div>
            <div className="col-md-3  d-flex justify-content-end mt-md-0">
              <div className="d-flex">
                <div className="me-2">
                  <p className=" text-muted">Booking Id:</p>
                  <p className="text-muted">Booking Date:</p>
                  <p className=" text-muted">Status:</p>
                </div>
                <div>
                  <p className="fw-bold">
                    {replaceEMTwithEWTS(bookingId) ?? " "}
                  </p>
                  <p className="fw-bold">{bookingDate}</p>
                  <p className="fw-bold text-success">Confirmed</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="booking-details bg-white p-4 shadow-sm">
          <div className="flight-info">
            <div className="d-md-flex justify-content-between section-title">
              <h5 className="h4 ">Flight Information</h5>
              <div className="user-button flight-booking-btns">
                <MuiButton
                  style={{ backgroundColor: "rgb(67 49 39)", width: "100%" }}
                  className="clear-btn"
                  label="Download"
                  type="button"
                  onClick={() => downloadTicket()}
                  startIcon={<FileDownloadIcon />}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-8">
                <div className="flight-route">
                  {outBoundFlight &&
                    renderFlightInfo(outBoundFlight, "Outbound Flight")}
                  {inBoundFlight &&
                    renderFlightInfo(inBoundFlight, "Inbound Flight")}
                </div>
              </div>
              {seatInfo?.length > 0 && (
                <div className="col-md-4">
                  <div className="passenger-info mb-1">
                    <div className="info-card">
                      <h3>Additional Services</h3>
                      <div className="info-item">
                        <span className="info-label">Seat</span>
                        <span className="info-value status-selected">
                          {seatInfo?.map((i: any) => i?.SeatNumber).join(", ")}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Meal</span>
                        <span className="info-value">
                          {mealInfo?.map((i: any) => i?.Detail).join(", ")}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Baggage</span>
                        <span className="info-value status-confirmed">
                          {baggageInfo?.map((i: any) => i?.Detail).join(", ")}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="passenger-info mb-1">
            <h5 className="section-title">Passenger Information</h5>
            <div className="table-responsive">
              <table className="table table-hover">
                <thead className="table-light">
                  <tr>
                    <th>Full Name</th>
                    <th>Email Address</th>
                    <th>Contact Number</th>
                    <th>Nationality </th>
                  </tr>
                </thead>
                <tbody>
                  {["AdultTraveller", "ChildTraveller", "InfantTraveller"].map(
                    (type) => {
                      const list = travellers[type] || [];

                      return list.map((traveller: any, index: number) => (
                        <>
                          {console.log("lkjh", traveller)}
                          <tr key={`${type}-${index}`}>
                            <td>{`${traveller.Title} ${traveller.FirstName} ${traveller.LastName}`}</td>
                            <td>{traveller.EmailAddress || "N/A"}</td>
                            <td>
                              {traveller.MobileNumber
                                ? (() => {
                                    const result = splitWithLookup(
                                      traveller.MobileNumber
                                    );
                                    return result && result.countryCode
                                      ? `+${result.countryCode} ${result.nationalNumber}`
                                      : "Invalid number";
                                  })()
                                : "N/A"}
                            </td>

                            <td>{traveller?.Nationality}</td>
                          </tr>
                        </>
                      ));
                    }
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="important-info mb-4">
            <h5 className="h5 section-title">Important Information</h5>

            <ul className="list-unstyled">
              <li className="mb-2">
                ✓ Please arrive at the airport at least 2 hours before departure
                for domestic flights and 3 hours for international flights.
              </li>
              <li className="mb-2">
                ✓ Make sure to carry a valid photo ID for domestic flights and
                passport for international flights.
              </li>
              <li className="mb-2">
                ✓ Check-in closes 45 minutes before departure.
              </li>
              <li className="mb-2">
                ✓ For any changes or queries related to your booking, please
                contact customer service at 1-800-123-4567.
              </li>
            </ul>
          </div>

          <div className="user-button w-full  my-0">
            <MuiButton
              startIcon={<ArrowForwardIcon />}
              className="clear-btn "
              label="Continue to booking"
              type="submit"
              onClick={() => navigate("/flightbooking")}
            />
            <MuiButton
              startIcon={<HistoryIcon />}
              className="main-btn get-btn"
              variant="contained"
              size="large"
              type="submit"
              label={"Booking History"}
              onClick={() => navigate("/flightbookinghistory")}
            />
          </div>
        </div>
        <div className="mt-2 text-center text-muted">
          <p>
            Thank you for choosing our service. We wish you a pleasant journey!
          </p>
        </div>
      </div>
    </div>
  );
};

export default FlightBookingConfirmation;
